import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import dayjs from "dayjs";
import { Action } from "../../../constants/Common";
import { withTranslation } from "react-i18next";

const IndividualDeliverable = (props) => {

  const handleKeyDownCost = (event) => {

    if (event.keyCode === 8 || event.keyCode === 13) {
        return;
    }
    const value = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    
    if (!regex.test(value + event.key)) {
        event.preventDefault(); 
    }
  }

  const handleKeyDownWeight = (event) => {

    if (event.keyCode === 8 || event.keyCode === 13) {
      return;
    }
   
    const regex = /^[0-9]+$/;

    if (!regex.test(event.key)) {
      event.preventDefault(); 
    }
  }
  return (
    <div className="editDeliverable_height h-auto my-3">
      {props?.action === Action.UPDATE && (
        <h6 className="mb-0">{props.t(props.eachDeliverableIndex + 1)}. {props.t('Current Deliverable')}</h6>
      )}
      <div className="dashed_border position-relative p-2">
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Name")}
              name="name"
              readOnly={true}
              required
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.name ?? ""
                  : typeof props?.eachDeliverable?.name === "object"
                  ? props?.eachDeliverable?.name?.old
                  : props?.eachDeliverable?.name
              }
            />
          </div>
        </div>
        <div className="row">
            <div className="col-sm-12 mt-2">
            <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label= {props.t("Description")}
                  name="description"
                  readOnly={true}
                  value={
                    props?.action === Action.CREATE
                      ? props?.eachDeliverable?.description ?? ""
                      : typeof props?.eachDeliverable?.description === "object"
                      ? props?.eachDeliverable?.description?.old
                      : props?.eachDeliverable?.description
                  }
                  multiline
                  required
                  rows={2}
                />
              </div>
              </div>
              <div className="row">
              <div className="col-sm-12 mt-2">
              <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label= {props.t("Expected Output")}
                  name="expectedOutput"
                  readOnly={true}
                  value={
                    props?.action === Action.CREATE
                      ? props?.eachDeliverable?.expectedOutput ?? ""
                      : typeof props?.eachDeliverable?.expectedOutput === "object"
                      ? props?.eachDeliverable?.expectedOutput?.old
                      : props?.eachDeliverable?.expectedOutput
                  }
                  multiline
                  required
                  rows={3}
                />
              </div>
              </div>
        <div className="row">
          <div className="col-md-6 mt-2 pe-0">
            {/* <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Cost")}
              name="cost"
              onKeyDown={handleKeyDownCost}
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">SAR</InputAdornment>
                ),
              }}
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.cost ?? ""
                  : typeof props?.eachDeliverable?.cost === "object"
                  ? props?.eachDeliverable?.cost?.old
                  : props?.eachDeliverable?.cost
              }
            /> */}
             <TextField
                sx={{ marginLeft: 3 }}
                minimumValue="0"
                id="deliverable-cost"
                // label='Deliverable Cost'
                decimalPlaces={2}
                readOnly={true}
                className="m-0"
                value={
                  props?.action === Action.CREATE
                    ? props?.eachDeliverable?.cost ?? ""
                    : typeof props?.eachDeliverable?.cost === "object"
                    ? props?.eachDeliverable?.cost?.old
                    : props?.eachDeliverable?.cost
                }
                variant="outlined"
                // size="small"
                currencySymbol={props.t("SAR")}
                fullWidth
                placeholder={props.t("Planned Cost")}
              />
          </div>
          <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Weight")}
              name="weight"
              onKeyDown={handleKeyDownWeight}
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.weight ??  ""
                  : typeof props?.eachDeliverable?.weight === "object"
                  ? props?.eachDeliverable?.weight?.old
                  : props?.eachDeliverable?.weight
              }
            />
          </div>
        </div>
        <div className="row">
          <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Start Date")}
              name="startDate"
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? (props?.eachDeliverable?.startDate
                      ? dayjs(props?.eachDeliverable?.startDate)
                      : ""
                    ).format("DD-MM-YYYY")
                  : typeof props?.eachDeliverable?.startDate === "object" &&
                    props?.eachDeliverable?.startDate?.old
                  ? dayjs(props?.eachDeliverable?.startDate?.old).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachDeliverable?.startDate
                  ? dayjs(props?.eachDeliverable?.startDate).format(
                      "DD-MM-YYYY"
                    )
                  : ""
              }
            />
          </div>
          <div className="col-md-6 changeRequest_datePicker mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("End Date")}
              name="endDate"
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.endDate
                    ? dayjs(props?.eachDeliverable?.endDate).format(
                        "DD-MM-YYYY"
                      )
                    : ""
                  : typeof props?.eachDeliverable?.endDate === "object" &&
                    props?.eachDeliverable?.endDate?.old
                  ? dayjs(props?.eachDeliverable?.endDate?.old).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachDeliverable?.endDate
                  ? dayjs(props?.eachDeliverable?.endDate).format("DD-MM-YYYY")
                  : ""
              }
            />
          </div>
        </div>
      </div>
      {props?.action === Action.UPDATE && (
        <div className="my-4">
          <h6 className="mb-0">{props.t('Requested Deliverable')}</h6>
          <div className="dashed_border position-relative p-2">
            <div className="row">
              <div className="col-md-12 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Name")}
                  name="name"
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.name === "object" ? "filled" : 'outlined'}`}
                  required
                  value={
                    typeof props?.eachDeliverable?.name === "object"
                      ? props?.eachDeliverable?.name?.new
                      : props?.eachDeliverable?.name
                  }
                />
              </div>
            </div>
            <div className="row">
            <div className="col-sm-12 mt-2">
            <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label= {props.t("Description")}
                  name="description"
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.description === "object" ? "filled" : 'outlined'}`}
                  value={
                    props?.action === Action.CREATE
                      ? props?.eachDeliverable?.description ?? ""
                      : typeof props?.eachDeliverable?.description === "object"
                      ? props?.eachDeliverable?.description?.old
                      : props?.eachDeliverable?.description
                  }
                  multiline
                  required
                  rows={2}
                />
              </div>
              </div>
              <div className="row">
              <div className="col-sm-12 mt-2">
              <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label= {props.t("Expected Output")}
                  name="expectedOutput"
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.expectedOutput === "object" ? "filled" : 'outlined'}`}
                  value={
                    props?.action === Action.CREATE
                      ? props?.eachDeliverable?.expectedOutput ?? ""
                      : typeof props?.eachDeliverable?.expectedOutput === "object"
                      ? props?.eachDeliverable?.expectedOutput?.new
                      : props?.eachDeliverable?.expectedOutput
                  }
                  multiline
                  required
                  rows={3}
                />
              </div>
              </div>
            <div className="row">
              <div className="col-md-6 mt-2 pe-0">
                {/* <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Cost")}
                  name="cost"
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">SAR</InputAdornment>
                    ),
                  }}
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.cost === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachDeliverable?.cost === "object"
                      ? props?.eachDeliverable?.cost?.new
                      : props?.eachDeliverable?.cost
                  }
                /> */}
                <TextField
                sx={{ marginLeft: 3 }}
                minimumValue="0"
                id="deliverable-cost"
                // label='Deliverable Cost'
                decimalPlaces={2}
                readOnly={true}
                className="m-0"
                value={
                  typeof props?.eachDeliverable?.cost === "object"
                    ? props?.eachDeliverable?.cost?.new
                    : props?.eachDeliverable?.cost
                }
                variant={`${typeof props?.eachDeliverable?.cost === "object" ? "filled" : 'outlined'}`}
                // size="small"
                currencySymbol={props.t("SAR")}
                fullWidth
                placeholder={props.t("Planned Cost")}
              />
              </div>
              <div className="col-md-6 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Weight")}
                  name="weight"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.weight === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachDeliverable?.weight === "object"
                      ? props?.eachDeliverable?.weight?.new 
                      : props?.eachDeliverable?.weight
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Start Date")}
                  name="startDate"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.startDate === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachDeliverable?.startDate === "object" &&
                    props?.eachDeliverable?.startDate?.new
                      ? dayjs(props?.eachDeliverable?.startDate?.new).format(
                          "DD-MM-YYYY"
                        )
                      : props?.eachDeliverable?.startDate
                      ? dayjs(props?.eachDeliverable?.startDate).format(
                          "DD-MM-YYYY"
                        )
                      : ""
                  }
                />
              </div>
              <div className="col-md-6 changeRequest_datePicker mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("End Date")}
                  name="endDate"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachDeliverable?.endDate === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachDeliverable?.endDate === "object" &&
                    props?.eachDeliverable?.endDate?.new
                      ? dayjs(props?.eachDeliverable?.endDate?.new).format(
                          "DD-MM-YYYY"
                        )
                      : props?.eachDeliverable?.endDate
                      ? dayjs(props?.eachDeliverable?.endDate).format(
                          "DD-MM-YYYY"
                        )
                      : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation() (IndividualDeliverable);
